import { Box, theme } from '@bpba/ui-components';

export const MenuAdhesion = () => {
    const Urls = [
        {
            id: '1',
            title: 'Adherí tu comercio',
            url: "/cdniComercios_app/"
        },
        {
            id: '2',
            title: 'Aprendé a usar la app',
            url: "/cdniComercios_app/TutorialAdhesionApp"
        },
        {
            id: '3',
            title: 'Preguntas Frecuentes',
            url: "/cuentadni/contenidos/cdniComerciosFaq"
        },
    ];

    return (
        <>
            <Box width={'100%'} minHeight={'2rem'} height={'auto'} display={'flex'} flexDirection={'row'} marginTop={'1rem'} justifyContent={"space-between"} flexWrap={["wrap", "nowrap", "nowrap", "nowrap"]}>

                <Box display={'flex'} flexDirection={'row'} marginTop={'1rem'} tabIndex={0}>
                    {Urls.map(({ title, id, url }) => (
                        <Solapa key={id} id={id} title={title} url={url} />
                    ))}
                </Box>
                <Box width={["50%", "30%", "30%", "30%"]} marginTop={'1rem'} justifyContent={["start", "end", "end", "end"]}>
                    <Box
                        width={"auto"}
                        paddingY={"0.5rem"}
                        paddingX={['1rem']}
                        alignItems={['center']}
                        border={['1px solid']}
                        borderColor={theme.colors.secondary[1]}
                        borderBottom={['none']}
                        borderRadius={['3px 8px 0 0']}
                        color={theme.colors.white}
                        tabIndex={0}
                    >
                        {' '}
                        <a
                            href={"/cuentadni/contenidos/cdniComerciosFaq"}
                            style={{ textDecoration: 'none', color: theme.colors.secondary[1], textAlign: 'center' }}
                            target="_blanc" tabIndex={0}
                        >
                            <a href='tel:08106662364' style={{ textDecoration: "none", color: theme.colors.secondary[1] }}>Te ayudamos: 0810 666 2364</a>
                        </a>
                    </Box>
                </Box>
            </Box>
            <Box width={['100%']} height={['1px']} backgroundColor={theme.colors.secondary[1]} marginY={['0.5rem']} />
        </>
    );
};

type PropsTab = {
    title: string;
    id: string;
    url: string;
};

const Solapa: React.FC<PropsTab> = ({ id, title, url }) => {

    let tabSelected;

    if (window.location.pathname == url) {
        tabSelected = true;
    } else {
        tabSelected = false;
    }

    return (
        <>
            {tabSelected ? 
             <Box
             width={'auto'}
             paddingY={"0.5rem"}
             paddingX={['1rem']}
             alignItems={['center']}
             border={['1px solid']}
             borderColor={theme.colors.secondary[1]}
             borderBottom={['none']}
             borderRadius={['3px 8px 0 0']}
             backgroundColor={theme.colors.secondary[1]}
             color={theme.colors.white}
             tabIndex={0}
             marginLeft={+id!==1?"10px":"0px"}
             marginRight={"10px"}
             key={id}
         >
              
             <a href={url}
                 style={{ textDecoration: 'none', color: theme.colors.white, textAlign: 'center' }} tabIndex={0}>
                 {title}
             </a>
           
         </Box>
            
            : 
            <Box width={"auto"}
            paddingY={"0.5rem"}
            paddingX={['1rem']}
            alignItems={['center']}
            border={['1px solid']}
            borderColor={theme.colors.secondary[1]}
            borderBottom={['none']}
            borderRadius={['3px 8px 0 0']}
            color={theme.colors.white}
            tabIndex={0}
            marginRight={+id!==3?"10px":"0px"}
            >
            <a href={url}
              style={{ textDecoration: 'none', color: theme.colors.secondary[1], textAlign: 'center' }} tabIndex={0}>
               {title}
            </a>
          </Box>
            
            }
      
        </>
    );
};
